import moment from "moment";
import React, { useState } from "react";
import { useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { ItemsService } from "shared/services";
import { AddAriaLabel } from "shared/utils/AddAriaLabel";
import PaginationListHOC from "../public/HOC/PaginationListHOC";
import { Breadcrumbs } from "shared/hoc/breadcrumbs/Breadcrumbs";
import { BREADCRUMB_TYPE_CONFIG } from "shared/hoc/breadcrumbs/config";
import "./Watching.scss"
import { FooterNew } from "../layouts";
const pageSize = 48
const fields = {
    "closing-soon": { field: "itemclosetime", direction: "asc" },
    "lowest-price": { field: "currentbid", direction: "asc" },
    "highest-price": { field: "currentbid", direction: "desc" },
    "won": { field: "biddingstatus", direction: "desc" },
    "not-won": { field: "biddingstatus", direction: "asc" },
    "listing-open": { field: "openitem", direction: "desc" },
    "listing-closed": { field: "closeditem", direction: "desc" },
};
export default function Watching(props) {
    const dispatch  = useDispatch()
    const userData = useSelector(state => state?.user);
    const statemaintenance = useSelector(state => state?.statemaintenance);
    const toggleSignInModal = useSelector(state => state?.toggleSignInModal);
    const [configeredData, setconfigeredData] = useState({})
    const [sneakpeek, setsneakpeek] = useState(false)
    const [selectAll, setselectAll] = useState(false)
    const [totalrecord, settotalrecord] = useState(0)
    const [slectedItems, setslectedItems] = useState([])
    const [totalItems, settotalItems] = useState([])
    const [filterData, setfilterData] = useState(null)
    useEffect(() => {
        if (totalItems.length > 0) {
            setselectAll(slectedItems.length == totalItems.length)
        } else {
            setselectAll(false)
        }
    }, [slectedItems,totalrecord])
    useEffect(() => {
        if (toggleSignInModal?.moveToHomeonCancel && !toggleSignInModal?.open && !userData?.id) {
        dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: false, mode: 'Sign-In',moveToHomeonCancel:false } });
        props?.history.push("/")
      }
    }, [toggleSignInModal])
    
  
    useEffect(() => {
        if( userData?.id) {
            let data = {
                sortkey:"closing-soon",
                closedItem:false,
            }
            if (statemaintenance?.["WatchList"]) {
                if (statemaintenance?.["WatchList"]?.filterData != filterData) {
                    data= statemaintenance?.["WatchList"]?.filterData
                }
            }
            setfilterData(data)

       } else {
           dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: 'Sign-In',moveToHomeonCancel:true } });
       }
       
    
      return () => {
      }
    }, [userData])
    
    useEffect(() => {
        if(filterData != null) {
            applyFilter()
        }
    }, [ filterData])
    const applyFilter = async ()=> {
        const commonUTC = moment.utc().format('YYYY-MM-DD HH:mm:ss');
        let payload = {
            "sort": [],
            "page": { "size": pageSize },
            "filter": []
        }
        payload["filter"].push({ "field": "sneekpeak", "value": 1, op: "=", join: "AND" })
        if (!filterData?.closedItem) {
            payload["filter"] = [...payload["filter"], { "field": "itemclosetime", "value": null, "op": "IS", "join": "OR" },
            { "field": "itemclosetime", "value": commonUTC, "op": ">", "join": "AND" }]
        }
        // if (sneakpeek) {
        //     payload["filter"].push({ "field": "sneekpeak", "value": 1, op: "=", join: "AND" })
        // }
        if (filterData?.sortkey != "") {
            payload["sort"] = [fields[filterData?.sortkey]]
        }
        let pusttoStore = { ...statemaintenance }
        pusttoStore["WatchList"] = {
            ...pusttoStore?.["WatchList"],
            filterData: filterData,
        }
        dispatch({
            type: 'PUSH_TO_STATE', payload: pusttoStore
        });
        setconfigeredData({
            payload,
            count: 4,
            pageSize: pageSize,
            type: "WatchList",
            history: props?.history,
            heading:"WatchList"
        })
    }
    const removeWatch = () => {
        const removeData = {
            "data": {
                "itemIds": slectedItems
            }
        };
        ItemsService.removeFromWatch(removeData).then(
            response => {
                applyFilter()
            }
        ).catch(error => {
        });
    }
    return (
        <div >
             <Helmet>
                <title>CTBids | {"Watchlist"}</title>
            </Helmet>
            <Breadcrumbs props={props} type={BREADCRUMB_TYPE_CONFIG.WATCHLIST} />


            <div className="watchlist">
                <AddAriaLabel loading={false} config={[
                    { id: 'sneakpeekSelect', label: 'Include Sneak Peek Items' },
                    { id: 'closedItemsSelect', label: 'Include Closed Items' },
                    { id: 'customControlSelect', label: 'Select All' }
                ]} />
                <div>
                    <div className="watch-header">Watchlist {totalrecord > 0 && `(${totalrecord} item${totalrecord >1 ?"s":""})`}</div>
                </div>
                <div className="filterflex-view">
                    <div className="sorbyHOC">
                        <Form.Group controlId="sort-by">
                            <Form.Label className="sort-label">Sort by</Form.Label>
                            <Form.Select as="select" aria-label='sort by' className="sort" onChange={(event) => {
                              setfilterData({
                                ...filterData,
                                sortkey:event?.target?.value
                            })
                            }} value={filterData?.sortkey}>
                                <option value="closing-soon">Closing Soon</option>
                                <option value="lowest-price">Lowest Price</option>
                                <option value="highest-price">Highest Price</option>
                                {/* <option value="listing-open">Open</option> */}
                                {/* <option value="listing-closed">Closed</option> */}
                                {filterData?.closedItem && <> <option value="won">Won</option>
                                    <option value="not-won">Not Won</option></>}
                            </Form.Select>
                            </Form.Group>
                    </div>
                    <div className="checkboxflex-view">
                        {/* <Form.Group className="d-flex gap-2 align-items-center">
                        <Form.Check
                            type="checkbox"
                            checked={sneakpeek}
                            aria-label='Include Sneak peek Items'
                            onChange={() => { setsneakpeek(!sneakpeek) }}
                        />
                        <div>Include Sneak peek Items</div>
                    </Form.Group> */}
                        <Form.Group className="d-flex gap-2 align-items-center watch-label">
                            <Form.Check
                                type="checkbox"
                                checked={filterData?.closedItem}
                                aria-label='Include Closed Items'
                                onChange={() => {
                                    setfilterData((prevstate) => {
                                        prevstate["closedItem"] = !filterData?.closedItem
                                        return ({ ...prevstate })
                                    })
                                }}
                            />
                            <div>Include Closed Items</div>
                        </Form.Group>
                        {totalItems?.length > 0 && <Form.Group className="d-flex gap-2 align-items-center watch-label">
                            <Form.Check
                                type="checkbox"
                                checked={selectAll}
                                aria-label='Select All'
                                onChange={() => {
                                    setslectedItems(!selectAll ? totalItems : [])
                                    // setselectAll(!selectAll)
                                }}
                            />
                            <div>Select All</div>
                        </Form.Group>}
                        {totalItems.length > 0 &&<Button className="removebtn" style={{ opacity: slectedItems.length > 0 ? 1 : 0.5 }} disabled={slectedItems.length <= 0} onClick={() => { removeWatch() }}>Remove</Button>}
                    </div>

                </div>
                <div className="px-2 w-100">
                    <PaginationListHOC
                        config={{ ...configeredData, selectedList: slectedItems }}
                        emptyCont={<div className="empty-cont">You don't have any items.</div>}
                        onRestCall={(data) => {
                            if (typeof data == "object" && "totalid" in data) {
                                settotalItems(data?.totalid)
                                setslectedItems([])
                            } else if (typeof data == "object" && "id" in data) {
                                let selected = [...slectedItems]
                                if (selected.includes(data?.id)) {
                                    selected = selected.filter(id => id != data?.id)
                                } else {
                                    selected.push(data?.id)
                                }
                                setslectedItems(selected)
                            } else {
                                settotalrecord(data)
                            }
                        }}
                    />
                </div>
            </div>
        </div>
    )
}